module.exports = __webpack_public_path__ + "img/flyer_05.048f4fe7.jpeg";